import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { QrDisplay } from './Display.js';
import { createSignPayload } from './util.js';
function DisplayPayload({ address, className, cmd, genesisHash, payload, size, style, timerDelay }) {
    const data = useMemo(() => createSignPayload(address, cmd, payload, genesisHash), [address, cmd, payload, genesisHash]);
    if (!data) {
        return null;
    }
    return (_jsx(QrDisplay, { className: className, size: size, style: style, timerDelay: timerDelay, value: data }));
}
export const QrDisplayPayload = React.memo(DisplayPayload);
